import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { StaticAction } from '../StaticAction/StaticAction';
import { StaticBackToTopLink } from '../StaticBackToTopLink/StaticBackToTopLink';
import type { StaticActionLink } from '../types';

type StaticPageSectionFooterProps = Omit<ComponentProps<'div'>, 'children'> & {
  backToTopLabel?: string;
  action?: StaticActionLink;
};

/**
 * Footer of a {@link StaticPageSection}.
 *
 * Renders the section's trailing action and the back link on one row, each
 * only when supplied. Renders nothing when neither is.
 *
 * @param backToTopLabel - Optional label for the jump-to-header link
 * @param action - Section footer action from page JSON
 * @param props - Remaining `div` attributes, such as `className` and `data-testid`
 */
function StaticPageSectionFooter({ backToTopLabel, action, className, ...props }: StaticPageSectionFooterProps) {
  if (!backToTopLabel && !action) {
    return null;
  }

  return (
    <div className={twMerge('flex flex-wrap gap-4', className)} {...props}>
      {action ? <StaticAction action={action} /> : null}
      {backToTopLabel ? <StaticBackToTopLink label={backToTopLabel} /> : null}
    </div>
  );
}

export { StaticPageSectionFooter, type StaticPageSectionFooterProps };
